import React from 'react'

const SupplierInformation = ({ supplier }) => {
  if (!supplier) return null

  return (
    <div style={{ marginTop: 24, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
      <p>
        <strong>Contact:</strong> {supplier.contactPerson}
      </p>
      <p>
        <strong>Email:</strong> {supplier.email}
      </p>
      <p>
        <strong>Phone:</strong> {supplier.phone}
      </p>
      <p>
        <strong>Lead Time:</strong> {supplier.leadTimeDays} days
      </p>
    </div>
  )
}

export default SupplierInformation
